import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import RachelSparkIcon from '../RachelSparkIcon/RachelSparkIcon';
import { getShimmerTextSx } from '../shimmerText';

interface RachelThinkingIndicatorProps {
  label: string;
}

const RachelThinkingIndicator = ({ label }: RachelThinkingIndicatorProps) => (
  <Stack direction="row" gap={1.25} alignItems="center">
    <RachelSparkIcon size={20} isPulsing />
    <Typography
      variant="body2"
      sx={(theme) => getShimmerTextSx(theme, { start: 50, middle: 70, end: 90 })}
    >
      {label}
    </Typography>
  </Stack>
);

export default RachelThinkingIndicator;
